import { sync } from 'vuex-pathify';

export default {

  data() {
    return {
      questions: {
        1: 'What makes you feel alive?',
        2: 'What are you doing when you\'re not working?',
        3: 'What\'s an interesting travel situation you were in?',
      },
    };
  },

  computed: {
    ...sync([
      'navigation/usersOnlineUnique', //
    ]),

    isOnline() {
      if (this.usersOnlineUnique.length) {
        if (this.usersOnlineUnique.some(e => e.uuid === this.data.profile.uuid)) {
          return true;
        }
      }

      return false;
    },

    lastOnline() {
      return this.isOnline ? `${this.data.profile.nickname} is online Now!` : `${this.data.profile.nickname} was last online on ${this.data.lastOnline}`;
    },

    lastOnlineIcon() {
      return this.isOnline ? 'fas fa-circle' : 'far fa-circle';
    },

    thumbBorderClass() {
      return this.isOnline ? 'img-responsive online' : 'img-responsive';
    },

    bio() {
      // let bio = this.data.profile.bio ? this.data.profile.bio : 'n/a';
      // const maxLength = 250;
      //
      // if (this.mode == 'search' && bio.length > maxLength) {
      //     bio = bio.substr(0, maxLength);
      //     bio = bio.substr(0, Math.min(bio.length, bio.lastIndexOf(" ")));
      //     bio += " <a href='" + this.profileLink + "'>more...</a>";
      // }

      // console.log('profile-fields.bio', this.data.profile);

      return this.data.profile.bio;
    },

    goalsValues() {
      return this.data.profile.goalsValues || '';
    },

    favouriteQuote() {
      return this.data.profile.favouriteQuote || '';
    },

    lookingFor() {
      if (this.data.profile.matchingPreferences.gender.male && this.data.profile.matchingPreferences.gender.female) { return 'men and women'; }
      if (this.data.profile.matchingPreferences.gender.male) { return 'men'; }
      if (this.data.profile.matchingPreferences.gender.female) { return 'women'; }
    },

    interestedIn() {
      if (this.data.profile.interestedIn) {
        return this.data.profile.interestedIn;
      }
      return 'not specified';
    },

    thumb() {
      if (this.data.profile.mainPicture.id) { return `${this.$api}${this.data.profile.mainPicture.thumb}`; }
      return 'https://via.placeholder.com/150x150';
    },

    thumbHq() {
      if (this.data.profile.mainPicture.id) { return `${this.$api}${this.data.profile.mainPicture.optimized}`; }
      return 'https://via.placeholder.com/150x150';
    },
  },
};
